export const API_URL = '/v2/api/ui';
// AB#84606 TEMP: v3/RoadRunner-ported GET endpoints (revert together with the v3 PoC squash)
export const API_URL_V3 = '/v3/api/ui';
